import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { fetchPost } from "../utils";
import { useDoubleCheck, useRedirect, useError } from "../hooks";
import { MainContext } from "../context/main";

export default function Mfa() {
  const [rawToken, setRawToken] = useState("");
  const history = useHistory();
  const { setError } = useError();
  const { mainDispatch } = useContext(MainContext);
  const redirect = useRedirect();
  useDoubleCheck();

  const submit = async function (e) {
    e.preventDefault();
    const { body, error } = await fetchPost({
      data: { token: rawToken },
      url: "/api/mfa-token",
    });
    if (body) {
      console.log("body");
      console.log(body);
      mainDispatch({
        type: "MAIN_SET_USER",
        user: body,
      });
      if (redirect) {
        history.push(redirect);
      } else {
        history.push("/home");
      }
    } else if (error) {
      setError(error);
    }
  };

  return (
    <>
      <h1>Enter your access code</h1>
      <p>
        <strong>
          We've sent an access code to the phone number provided. Please enter
          the code here:
        </strong>
      </p>
      <form onSubmit={submit}>
        <label htmlFor="mfa-token">Token</label>
        <input
          autoFocus
          autoComplete="one-time-code"
          id="mfa-token"
          inputMode="numeric"
          name="mfa-token"
          pattern="[0-9]*"
          type="text"
          value={rawToken}
          onChange={({ target: { value } }) => setRawToken(value)}
        />
        <br />
        <button type="submit">Submit</button>
      </form>
      <br />
      <br />
      <a href="/logout">Problems? Click here to re-enter your phone</a>
    </>
  );
}
